// extracted by mini-css-extract-plugin
export default {"progressCell":"ProgressCell_progressCell__2kgwy"};